import { FC, createContext, Dispatch, ReactNode, SetStateAction, useContext } from "react";

type PointsExperienceListingContextType = {
  selectedType: number;
  setSelectedType: Dispatch<SetStateAction<number>>;
};

const PointsExperienceListingContext = createContext<null | PointsExperienceListingContextType>(null);

const PointsExperienceListingProvider: FC<{
  value: PointsExperienceListingContextType;
  children: ReactNode;
}> = ({
  value,
  children,
}) => {
  return <PointsExperienceListingContext.Provider value={value}>{children}</PointsExperienceListingContext.Provider>;
};

const usePointsExperienceListing = () => {
  const context = useContext(PointsExperienceListingContext);
  if (!context) throw new Error("Illegal Usage of Context outside the PointsExperienceListingContext");
  return context;
};

export { PointsExperienceListingProvider, usePointsExperienceListing };
